import { Application } from "@hotwired/stimulus"
import TierTabsController from "./controllers/tier_tabs_controller"
import VenueCarouselController from "./controllers/venue_carousel_controller"
import RsvpModalController from "./controllers/rsvp_modal_controller"
import MultiSelectController from "./controllers/multi_select_controller"
import FormErrorsController from "./controllers/form_errors_controller"

const application = Application.start()
application.register("tier-tabs", TierTabsController)
application.register("venue-carousel", VenueCarouselController)
application.register("rsvp-modal", RsvpModalController)
application.register("multi-select", MultiSelectController)
application.register("form-errors", FormErrorsController)
